import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  header: string = '';
  message: string = '';
  translateY = 'translateY(-100%)';

  isShowing = false;

  constructor() { }

  alert(alert: string) {
    this.message = alert;
    this.isShowing = true;
    setTimeout(() => {
      this.translateY = 'translateY(50%)'
    }, 100);
  }

  cleanData() {
    this.header = '';
    this.message = '';
  }

  close() {
    this.translateY = 'translateY(-100%)'
    setTimeout(() => {
      this.isShowing = false;
      this.cleanData();
    }, 600);
  }

}
